import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Adjust path if needed
import { collection, onSnapshot, query, where, orderBy } from 'firebase/firestore';
import './AdminPages.css';

const HubView = () => {
    const [hubs, setHubs] = useState([]);
    const [selectedHub, setSelectedHub] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [loadingHubs, setLoadingHubs] = useState(true);
    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [error, setError] = useState(null);

    // Effect to fetch all hubs
    useEffect(() => {
        const hubsQuery = query(collection(db, 'hubs'), orderBy('createdAt', 'desc'));
        const unsubscribe = onSnapshot(hubsQuery, 
            (snapshot) => {
                setHubs(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                setLoadingHubs(false);
            },
            (err) => {
                console.error("Error fetching hubs:", err);
                setError("Could not load hubs. Please try again later.");
                setLoadingHubs(false);
            }
        );
        return () => unsubscribe();
    }, []);

    // Effect to fetch customers for the selected hub
    useEffect(() => {
        if (!selectedHub) {
            setCustomers([]);
            return;
        }

        setLoadingCustomers(true);
        setError(null); // Clear previous errors

        // --- THIS IS THE CORRECTED QUERY ---
        // It now queries the 'customers' collection, which matches your database screenshot.
        const customersQuery = query(
            collection(db, 'customers'), // CORRECTED: Changed from 'users' to 'customers'
            where('hub', '==', selectedHub.hubName) 
        );

        const unsubscribe = onSnapshot(customersQuery, 
            (snapshot) => {
                setCustomers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                setLoadingCustomers(false);
            },
            (err) => {
                console.error("Error fetching customers:", err);
                setError("Failed to load customers. You may need to create a Firestore index. Check the console (F12) for a link.");
                setLoadingCustomers(false);
            }
        );

        return () => unsubscribe();
    }, [selectedHub]); // This effect re-runs whenever 'selectedHub' changes

    if (loadingHubs) {
        return <div className="admin-page-container"><h2>Loading Hubs...</h2></div>;
    }

    return (
        <div className="admin-page-container">
            <h1>View Hubs and Customers</h1>
            {error && <p className="error-message">{error}</p>}
            <div className="hub-view-layout">
                <div className="card hub-list-card">
                    <h2>Select a Hub</h2>
                    {hubs.length > 0 ? (
                        <ul className="hubs-list">
                            {hubs.map(hub => (
                                <li
                                    key={hub.id}
                                    className={selectedHub?.id === hub.id ? 'selected' : ''}
                                    onClick={() => setSelectedHub(hub)}
                                >
                                    {hub.hubName}
                                    <span>{hub.location}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No hubs found.</p>
                    )}
                </div>

                <div className="card customer-list-card">
                    <h2>Customers in "{selectedHub ? selectedHub.hubName : 'No Hub Selected'}"</h2>
                    {loadingCustomers ? (
                        <p>Loading customers...</p>
                    ) : (
                        <ul>
                            {customers.length > 0 ? (
                                customers.map(customer => (
                                    <li key={customer.id} className="customer-item">
                                        <strong>{customer.name || 'No Name'}</strong> 
                                        <span>Email: {customer.email || 'N/A'}</span>
                                        <span>Mobile: {customer.mobile || 'N/A'}</span>
                                    </li>
                                ))
                            ) : (
                                <p>{selectedHub ? 'No customers found for this hub.' : 'Please select a hub to view customers.'}</p>
                            )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HubView;